/**
 * DI-02 intent matcher — does this chat prompt ask to list the speaker notes?
 *
 * Accepted phrasings (spec §6, DI-02): "List the notes", "show me the speaker
 * notes", "read the notes", "what are the notes", "where are the notes",
 * "view all notes". Matching is anchored at the start of the prompt so
 * requests that merely mention notes ("add this as speaker notes", "write
 * notes for slide 3") fall through to the AI instead.
 */

const LEAD = String.raw`^\s*(?:please\s+)?(?:can\s+you\s+|could\s+you\s+)?`;
const TAIL = String.raw`(?:\s+(?:the|my|all|of\s+the))*(?:\s+speaker)?\s+notes\b`;

const PATTERNS: readonly RegExp[] = [
  // list / show / read / view / display / see [me] [all] [the] [speaker] notes
  new RegExp(String.raw`${LEAD}(?:list|show|read|view|display|see)(?:\s+me)?${TAIL}`, "i"),
  // what / where are [the] [speaker] notes
  new RegExp(String.raw`${LEAD}(?:what|where)\s+(?:are|r)${TAIL}`, "i"),
];

export function matchListNotesIntent(prompt: string): boolean {
  const text = prompt.trim();
  if (!text || text.startsWith("/")) return false;
  return PATTERNS.some((re) => re.test(text));
}
